import React from 'react';

export default function OffCanvas({ children, open, toggle }) {
    return (
        <>
            <div className={"offcanvas" + (open ? ' open' : '')}>
                {children}
            </div>
            <div className={"offcanvas-backdrop" + (open ? ' open' : '')} onClick={toggle}></div>
        </>
    );
}
